import React, { useState, useEffect, useMemo, useRef } from "react";
import {
  Checkbox,
  Rate,
  Button,
  Popover,
  Tooltip,
  Image,
  Input,
  Empty,
  Avatar,
} from "antd";
import Text from "antd/lib/typography/Text";
import defaultImage from "../../../../assets/brandLogos/Default_Brand.svg";
import { SocialMedialogo } from "../../DeepDive/DeepDivetab/SocialMediaPlatforms";
import { VariableSizeList } from "react-window";
import { useSelector, useDispatch } from "react-redux";
import location from "../../../../assets/location.svg";
import accoArrow from "../../../../assets/acco_arrow-up.svg";
import accoArrowWhite from "../../../../assets/WhiteIcons/acco_arrow-upWhite.svg";
import NoDataFound from "../../../../assets/No_Data_Found.svg";
import {
  setAdsListInPane,
  setAdssetListInPane,
  setAdssetValueInPane,
  setAdsValueInPane,
  setClearGraphData,
  setClearGraphDataInShareDashboard,
  setGlobalFilter,
  setProfileInfoPane,
} from "../../../../redux/actions/dashboard/Tab1";
import {
  getPaneIndex,
  processQuickFilterForScheduleADCampaign,
} from "../../../../redux/constants";
import { setScheduleQuickFilter } from "../../../../redux/actions/scheduleReport/scheduleReport";
// import styled from "styled-components";
import isEqual from "react-fast-compare";
import { getCampaignStatusIcons } from "../../../../redux/constants/CampaignStatusIcons";
import {
  setAdsListInShareModal,
  setAdssetListInShareModal,
  setAdssetValueInShareModal,
  setAdsValueInShareModal,
  setSelectedProfileInfoInShareModal,
} from "../../../../redux/actions/share/Share";
import {
  setAdsListInShareDashboard,
  setAdssetListInShareDashboard,
  setAdssetValueInShareDashboard,
  setAdsValueInShareDashboard,
  setSelectedProfileInfoInShareDashboard,
} from "../../../../redux/actions/ApiCall/apiCall";

const MultipleQuickFiltersSelectDropdown = ({
  type,
  AccountType,
  supportedAccountTypeList = [],
  IsAdsSetType = false,
  IsAdsType = false,
  isSwitchingAllowed = false,
}) => {
  const dispatch = useDispatch();
  const [search, setSerachString] = useState("");
  const [selectedOptions, setSelectedOption] = useState([]);
  const [quickFilterOptions, setQuickFilterOptions] = useState([]);
  const [visibleOptions, setVisibleOptions] = useState([]);
  const listRef = useRef(null);

  const panes = useSelector((state) => state?.Tab1?.panes);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const [visible, setVisible] = useState(false);
  const [visibleOfTooltip, setVisibleOfTooltip] = useState(false);
  const authParams = useSelector((state) => state.Authentication.authParams);
  const brands = useSelector(
    (state) => state?.ApiCall?.brands?.data?.result?.brands
  );
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const scheduleObj = useSelector((state) => state.scheduleReport.scheduleObj);
  const index = getPaneIndex(panes, activeKey);
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const competitorBrands = useSelector(
    (state) => state.WidgetAPI.competitorBrands?.data?.result
  );
  const temporary_words = useSelector(
    (state) => state.attributes.temporary_words
  );
  const multileProfileSelectionInShare = useSelector(
    (state) => state?.ApiCall?.multileProfileSelection
  );
  const shareCategory = useSelector((state) => state?.ApiCall?.shareCategory);
  const shareBrands = useSelector((state) => state?.ApiCall?.shareBrands);
  const shareTemplateData = useSelector(
    (state) => state?.ApiCall?.shareTemplateData
  );
  const profileSelectionInfo = useSelector(
    (state) => state?.Share?.profileSelectionInfo
  );

  // const quickFiterValues =
  //   type === "share-modal" && isSwitchingAllowed
  //     ? IsAdsType
  //       ? profileSelectionInfo?.ads_value?.columns
  //         ? profileSelectionInfo?.ads_value?.columns
  //         : panes?.[index]?.ads_value?.columns
  //       : IsAdsSetType
  //       ? profileSelectionInfo?.adsset_value?.columns
  //         ? profileSelectionInfo?.adsset_value?.columns
  //         : panes?.[index]?.adsset_value?.columns
  //       : profileSelectionInfo?.quick_filter_value
  //       ? profileSelectionInfo?.quick_filter_value?.columns
  //       : panes?.[index]?.quick_filter_value?.columns
  //     : IsAdsType
  //     ? panes?.[index]?.ads_value?.columns
  //     : IsAdsSetType
  //     ? panes?.[index]?.adsset_value?.columns
  //     : panes?.[index]?.quick_filter_value?.columns;

  const getQuickFilterValues = () => {
    // 1. Decide which object holds the “override” data (only for share‑modal + switching)
    const sourceToGetValues =
      type === "share-modal" && isSwitchingAllowed
        ? profileSelectionInfo
        : type === "share-dashboard" &&
          multileProfileSelectionInShare?.allow_multiple_selection
        ? shareTemplateData
        : panes?.[index];

    // 2. Pick the right property name
    const keyToGetQuickFilterValues = IsAdsType
      ? "ads_value"
      : IsAdsSetType
      ? "adsset_value"
      : "quick_filter_value";
    // 3. Grab columns, falling back to the pane if missing
    const quickFiterValues =
      sourceToGetValues?.[keyToGetQuickFilterValues]?.columns ??
      panes?.[index]?.[keyToGetQuickFilterValues]?.columns;
    return quickFiterValues;
  };
  const quickFiterValues = useMemo(
    () => getQuickFilterValues(),
    [
      panes,
      profileSelectionInfo,
      multileProfileSelectionInShare,
      shareTemplateData,
    ]
  );

  const getProfileList = () => {
    return multileProfileSelectionInShare?.allow_multiple_selection
      ? IsAdsType
        ? shareTemplateData?.ads_list
        : IsAdsSetType
        ? shareTemplateData?.adsset_list
        : shareTemplateData?.profile_list
      : profileSelectionInfo?.is_value_updated_from_share_modal
      ? IsAdsType
        ? profileSelectionInfo?.ads_list
        : IsAdsSetType
        ? profileSelectionInfo?.adsset_list
        : panes[index]?.profiles
      : IsAdsType
      ? panes?.[index]?.ads_list
      : IsAdsSetType
      ? panes[index]?.adsset_list
      : panes[index]?.profiles;
  };
  const updatedProfileList = useMemo(
    () => getProfileList(),
    [
      panes,
      profileSelectionInfo,
      multileProfileSelectionInShare,
      shareTemplateData,
    ]
  );
  const dontShowProfileUIFor = ["Ads_Campaign", "ProfileID"];
  const isSupportedAccountType =
    supportedAccountTypeList?.includes(AccountType);
  // const showSearchInput =
  //   (isSupportedAccountType && quickFilterOptions?.length > 10) ||
  //   AccountType !== "AccountID";
  // const isSelectionDisabled =
  //   selectedOptions?.length > 50 || selectedOptions?.length === 0;
  const getDefaultValues = () => {
    const setdefaultValue = quickFiterValues?.reduce((acc, data) => {
      const locationIndex = updatedProfileList?.findIndex(
        (obj) =>
          obj?.id?.toString() === data?.name?.toString() ||
          obj?.id?.toString() === data?.id?.toString()
      );
      const details = updatedProfileList?.[locationIndex];
      acc.push(details);
      return acc;
    }, []);
    return setdefaultValue;
  };

  useEffect(() => {
    if (updatedProfileList) {
      const setdefaultValue = getDefaultValues();
      setSelectedOption(setdefaultValue);
      setQuickFilterOptions(updatedProfileList);
    }
  }, [updatedProfileList]);

  const handleSearch = (e) => {
    let value = e?.target?.value;
    setSerachString(value);
  };

  const filteredResults = (term) => {
    if (term.trim()) {
      const searchWords = term.trim().toLowerCase().split(" ");
      return quickFilterOptions?.filter((data) => {
        return searchWords.every((word) => {
          return (
            data?.name?.toLowerCase().includes(word) ||
            data?.StoreAddress?.toString().toLowerCase().includes(word) ||
            (data?.StoreCode &&
              data?.StoreCode !== "" &&
              data?.StoreCode?.toLowerCase().includes(word))
          );
        });
      });
    }
  };

  const handleOnSelectChange = (data, el) => {
    if (data?.target?.checked) {
      if (
        data?.target?.value === "All Locations" ||
        data?.target?.value === "All Accounts" ||
        data?.target?.value === "All Location Profiles" ||
        (AccountType === "Ads_Campaign" &&
          (IsAdsType
            ? data?.target?.value === "All ADs"
            : IsAdsSetType
            ? data?.target?.value === "All AD Sets"
            : data?.target?.value === "All AD Campaigns"))
      ) {
        setSelectedOption([el]);
      } else {
        let selectedValues = [...selectedOptions, el];
        selectedValues =
          selectedValues?.length === quickFilterOptions?.length - 1
            ? quickFilterOptions
            : selectedValues;
        if (
          selectedValues?.length === quickFilterOptions?.length &&
          selectedValues?.[0]?.name &&
          ((AccountType === "LocationID" &&
            selectedValues?.[0]?.name === "All Locations") ||
            (isSupportedAccountType &&
              AccountType !== "Ads_Campaign" &&
              ["All Accounts", "All Location Profiles"]?.includes(
                selectedValues?.[0]?.name
              )) ||
            (AccountType === "Ads_Campaign" &&
              (IsAdsType
                ? selectedValues?.[0]?.name === "All ADs"
                : IsAdsSetType
                ? selectedValues?.[0]?.name === "All AD Sets"
                : selectedValues?.[0]?.name === "All AD Campaigns")))
        ) {
          setSelectedOption([selectedValues?.[0]]);
        } else {
          setSelectedOption(selectedValues);
        }
      }
    } else {
      if (data?.target?.value === "All Locations" && !data?.target?.checked) {
        setSelectedOption([]);
      } else if (
        (data?.target?.value === "All Accounts" ||
          data?.target?.value === "All Location Profiles" ||
          (AccountType === "Ads_Campaign" &&
            (IsAdsType
              ? data?.target?.value === "All ADs"
              : IsAdsSetType
              ? data?.target?.value === "All AD Sets"
              : data?.target?.value === "All AD Campaigns"))) &&
        !data?.target?.checked
      ) {
        setSelectedOption([]);
      } else {
        const index = selectedOptions?.findIndex(
          (obj) =>
            obj?.name === "All Locations" ||
            obj?.name === "All Accounts" ||
            obj?.name === "All Location Profiles" ||
            (AccountType === "Ads_Campaign" &&
              (IsAdsType
                ? obj?.name === "All ADs"
                : IsAdsSetType
                ? obj?.name === "All AD Sets"
                : obj?.name === "All AD Campaigns"))
        );
        if (index !== -1) {
          let selectedOption = quickFilterOptions?.filter((obj) => {
            if (
              (AccountType === "LocationID"
                ? obj?.name !== "All Locations"
                : true) &&
              (isSupportedAccountType && AccountType !== "Ads_Campaign"
                ? !["All Accounts", "All Location Profiles"]?.includes(
                    obj?.name
                  )
                : true) &&
              (AccountType === "Ads_Campaign"
                ? IsAdsType
                  ? obj?.name !== "All ADs"
                  : IsAdsSetType
                  ? obj?.name !== "All AD Sets"
                  : obj?.name !== "All AD Campaigns"
                : true) &&
              obj?.id !== el?.id
            ) {
              return data;
            }
          });
          setSelectedOption(selectedOption);
        } else {
          const selectedValues = selectedOptions?.filter((obj) => {
            if (el?.id !== obj?.id) {
              return obj;
            }
          });
          setSelectedOption(selectedValues);
        }
      }
    }
  };

  const setIsCheckedOrNot = (data) => {
    const index = selectedOptions?.findIndex(
      (el) =>
        el?.name === "All Locations" ||
        el?.name === "All Accounts" ||
        el?.name === "All Location Profiles" ||
        (AccountType === "Ads_Campaign" &&
          (IsAdsType
            ? el?.name === "All ADs"
            : IsAdsSetType
            ? el?.name === "All AD Sets"
            : el?.name === "All AD Campaigns"))
    );
    if (index !== -1) {
      return true;
    } else {
      const selectedOptionIndex = selectedOptions?.findIndex(
        (el) => el?.id === data?.id
      );
      if (selectedOptionIndex !== -1) {
        return true;
      } else {
        return false;
      }
    }
  };
  const handleVisibleChangeOfTooltip = (newVisible) => {
    setVisibleOfTooltip(newVisible);
  };
  const handleVisibleChange = (newVisible, resetOption = true) => {
    if (resetOption) {
      const setdefaultValue = getDefaultValues();
      setSelectedOption(setdefaultValue);
    }
    setVisible(newVisible);
    setVisibleOfTooltip(false);
    setSerachString("");
  };

  const handleCancel = (value) => {
    const setdefaultValue = getDefaultValues();
    setSelectedOption(setdefaultValue);
    setVisible(value);
    setSerachString("");
  };

  const handleDone = () => {
    onSubmitLocations(selectedOptions);
    handleVisibleChange(false, false);
    setQuickFilterOptions(updatedProfileList);
    if (listRef?.current) {
      listRef.current?.scrollToItem(0);
    }
  };

  const onSubmitLocations = (selectedLocation) => {
    let coloumData = [];
    let index = getPaneIndex(panes, activeKey);
    let allLocationIndex = selectedLocation?.findIndex(
      (obj) =>
        obj?.name === "All Locations" ||
        obj?.name === "All Accounts" ||
        obj?.name === "All Location Profiles" ||
        (AccountType === "Ads_Campaign" &&
          (IsAdsType
            ? obj?.name === "All ADs"
            : IsAdsSetType
            ? obj?.name === "All AD Sets"
            : obj?.name === "All AD Campaigns"))
    );
    if (allLocationIndex === -1) {
      coloumData = selectedLocation?.map((data) => {
        let details = {
          name: `${data?.id}`,
          type: "include",
          display_name: data?.name,
          store_code: data?.StoreCode,
          profile_icon_url: data?.profile_icon_url,
          channel: data?.channel,
          status: data?.status,
        };
        if (
          AccountType === "Ads_Campaign" &&
          IsAdsSetType &&
          data?.campaign_id
        ) {
          details.campaign_id = data?.campaign_id;
        } else if (
          AccountType === "Ads_Campaign" &&
          IsAdsType &&
          data?.campaign_id &&
          data?.adset_id
        ) {
          details.campaign_id = data?.campaign_id;
          details.adset_id = data?.adset_id;
        }
        return details;
      });
    } else {
      let details = {
        name: `${selectedLocation?.[allLocationIndex]?.id}`,
        type: "include",
        display_name: `${selectedLocation?.[allLocationIndex]?.name}`,
        store_code: `${selectedLocation?.[allLocationIndex]?.StoreCode}`,
      };
      coloumData = [details];
    }
    let listOfAdsset = [];
    let valueOfAdsset = null;
    let listOfAds = [];
    let valueOfAds = null;
    if (AccountType === "Ads_Campaign") {
      if (!IsAdsSetType && !IsAdsType) {
        if (allLocationIndex === -1) {
          selectedLocation?.forEach((op) => {
            if (Array.isArray(op?.ad_sets) && op?.ad_sets?.length) {
              let updatedAdSets = op?.ad_sets?.map((adSet) => {
                return { ...adSet, campaign_id: op?.id };
              });
              listOfAdsset = [...listOfAdsset, ...updatedAdSets];
            }
          });
          if (listOfAdsset?.length) {
            let allAdsSetObj = { id: -1, name: "All AD Sets" };

            let details = {
              name: `${allAdsSetObj?.id}`,
              type: "include",
              display_name: `${allAdsSetObj?.name}`,
            };
            let coloumDataForAdsset = [details];
            valueOfAdsset = {
              attribute: listOfAdsset?.[0]?.attribute,
              data_source:
                listOfAdsset?.[0]?.data_source || listOfAdsset?.[0]?.source,
              type: "varchar",
              columns: coloumDataForAdsset,
            };
            listOfAdsset?.unshift(allAdsSetObj);
          }
        } else {
          // if all campaign is selection at that time remove all list and values of ad's set
        }
        if (
          type === "share-dashboard" &&
          multileProfileSelectionInShare?.allow_multiple_selection
        ) {
          dispatch(setAdssetListInShareDashboard(listOfAdsset));
          dispatch(setAdssetValueInShareDashboard(valueOfAdsset));
          dispatch(setAdsListInShareDashboard([]));
          dispatch(setAdsValueInShareDashboard(null));
        } else if (type === "share-modal" && isSwitchingAllowed) {
          dispatch(setAdssetListInShareModal(listOfAdsset));
          dispatch(setAdssetValueInShareModal(valueOfAdsset));
          dispatch(setAdsListInShareModal([]));
          dispatch(setAdsValueInShareModal(null));
        } else {
          dispatch(setAdssetListInPane(listOfAdsset, index));
          dispatch(setAdssetValueInPane(valueOfAdsset, index));
          dispatch(setAdsListInPane([], index));
          dispatch(setAdsValueInPane(null, index));
        }
      } else if (IsAdsSetType) {
        if (allLocationIndex === -1) {
          selectedLocation?.forEach((op) => {
            if (Array.isArray(op?.ads) && op?.ads?.length) {
              let updatedAds = op?.ads?.map((ad) => {
                return {
                  ...ad,
                  campaign_id: op?.campaign_id,
                  adset_id: op?.id,
                };
              });
              listOfAds = [...listOfAds, ...updatedAds];
            }
          });
          if (listOfAds?.length) {
            let allAdsObj = { id: -1, name: "All ADs" };

            let details = {
              name: `${allAdsObj?.id}`,
              type: "include",
              display_name: `${allAdsObj?.name}`,
            };
            let coloumDataForAds = [details];
            valueOfAds = {
              attribute: listOfAds?.[0]?.attribute,
              data_source:
                listOfAds?.[0]?.data_source || listOfAds?.[0]?.source,
              type: "varchar",
              columns: coloumDataForAds,
            };
            listOfAds?.unshift(allAdsObj);
          }
        } else {
          // if all campaign is selection at that time remove all list and values of ad's
        }
        if (
          type === "share-dashboard" &&
          multileProfileSelectionInShare?.allow_multiple_selection
        ) {
          dispatch(setAdsListInShareDashboard(listOfAds));
          dispatch(setAdsValueInShareDashboard(valueOfAds));
        } else if (type === "share-modal" && isSwitchingAllowed) {
          dispatch(setAdsListInShareModal(listOfAds));
          dispatch(setAdsValueInShareModal(valueOfAds));
        } else {
          dispatch(setAdsListInPane(listOfAds, index));
          dispatch(setAdsValueInPane(valueOfAds, index));
        }
      }
    }
    let profileFilters = {
      attribute:
        AccountType === "Ads_Campaign" && (IsAdsSetType || IsAdsType)
          ? quickFilterOptions?.[1]?.attribute
          : type === "share-dashboard" &&
            multileProfileSelectionInShare?.allow_multiple_selection
          ? shareTemplateData?.quick_filter?.attribute === "AccountID"
            ? "SettingID"
            : shareTemplateData?.quick_filter?.attribute === "Category"
            ? "CategoryID"
            : shareTemplateData?.quick_filter?.attribute
          : panes[index]?.quick_filter === "AccountID"
          ? "SettingID"
          : panes[index]?.quick_filter === "Category"
          ? "CategoryID"
          : panes[index]?.quick_filter,
      data_source:
        AccountType === "Ads_Campaign" && (IsAdsSetType || IsAdsType)
          ? quickFilterOptions?.[1]?.data_source ||
            quickFilterOptions?.[1]?.source
          : type === "share-dashboard" &&
            multileProfileSelectionInShare?.allow_multiple_selection
          ? shareTemplateData?.quick_filter?.data_source ||
            shareTemplateData?.quick_filter?.source
          : panes[index]?.quick_filter_source
          ? panes[index]?.quick_filter_source
          : "mentions",
      type: "varchar",
      columns: coloumData,
    };
    let paneObj = {
      panes: panes,
      activeKey: activeKey,
      brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
      singleBrands: brands,
      authParams: authParams,
      index: index,
      competitorBrands: competitorBrands,
      graphConditionConfig: graphConditionConfig,
      temporary_words: temporary_words,
    };
    let profileInfo = {
      name: "",
      channelType: "",
      profileIcon: "",
    };

    if (
      type === "share-dashboard" &&
      multileProfileSelectionInShare?.allow_multiple_selection
    ) {
      if (!IsAdsSetType && !IsAdsType) {
        dispatch(
          setSelectedProfileInfoInShareDashboard(profileInfo, profileFilters)
        );
      } else if (IsAdsSetType) {
        dispatch(setAdssetValueInShareDashboard(profileFilters));
      } else if (IsAdsType) {
        dispatch(setAdsValueInShareDashboard(profileFilters));
      }
      let updatedShareTemplateData = { ...shareTemplateData };
      let shareObj = {
        shareBrands: shareBrands,
        shareTemplateData: updatedShareTemplateData,
        shareCategory: shareCategory,
        graphConditionConfig: graphConditionConfig,
        change_type: "global_profile",
      };
      dispatch(setClearGraphDataInShareDashboard("share", shareObj));
      return;
    } else if (type === "share-modal" && isSwitchingAllowed) {
      if (!IsAdsSetType && !IsAdsType) {
        dispatch(
          setSelectedProfileInfoInShareModal(profileInfo, profileFilters)
        );
      } else if (IsAdsSetType) {
        dispatch(setAdssetValueInShareModal(profileFilters));
      } else if (IsAdsType) {
        dispatch(setAdsValueInShareModal(profileFilters));
      }
      return;
    }

    if (!IsAdsSetType && !IsAdsType) {
      dispatch(setProfileInfoPane(profileInfo, index, panes, profileFilters));
    } else if (IsAdsSetType) {
      dispatch(setAdssetValueInPane(profileFilters, index));
    } else if (IsAdsType) {
      dispatch(setAdsValueInPane(profileFilters, index));
    }

    dispatch(
      setClearGraphData(index, panes, paneObj, {
        change_type: "global_profile",
      })
    );
    if (type === "schedule_report" && !IsAdsSetType && !IsAdsType) {
      let scheduleQuickFilter = profileFilters;
      scheduleQuickFilter.name = profileInfo?.name;
      scheduleQuickFilter.profile_icon_url = profileInfo?.profileIcon;
      let updatedColumnsMap = null;
      // new logic for formatting subset_filter in inner of columns
      if (AccountType === "Ads_Campaign" && valueOfAdsset?.attribute) {
        if (scheduleQuickFilter?.attribute === "Ads_Campaign") {
          // call to the function to get updated columns
          updatedColumnsMap = processQuickFilterForScheduleADCampaign(
            scheduleQuickFilter,
            valueOfAdsset
          );
        }
      }
      let quickFilterWithSubsetFilter = null;
      if (
        updatedColumnsMap &&
        Array.from(updatedColumnsMap?.values())?.length
      ) {
        quickFilterWithSubsetFilter = scheduleQuickFilter
          ? { ...scheduleQuickFilter }
          : null;
        if (
          quickFilterWithSubsetFilter?.columns &&
          Array.isArray(quickFilterWithSubsetFilter?.columns)
        )
          quickFilterWithSubsetFilter.columns = Array.from(
            updatedColumnsMap?.values()
          );
      }
      dispatch(
        setScheduleQuickFilter(
          quickFilterWithSubsetFilter
            ? quickFilterWithSubsetFilter
            : scheduleQuickFilter,
          scheduleObj
        )
      );
    } else if (
      type === "schedule_report" &&
      scheduleObj?.quick_filter &&
      (IsAdsSetType || IsAdsType)
    ) {
      let scheduleQuickFilter = scheduleObj?.quick_filter;
      // new logic for formatting subset_filter in inner of columns
      let updatedColumnsMap = null;
      if (
        AccountType === "Ads_Campaign" ||
        scheduleQuickFilter?.attribute === "Ads_Campaign"
      ) {
        // call to the function to get updated columns
        if (IsAdsSetType && profileFilters?.attribute) {
          updatedColumnsMap = processQuickFilterForScheduleADCampaign(
            scheduleQuickFilter,
            profileFilters,
            valueOfAds?.attribute ? valueOfAds : null
          );
        } else if (IsAdsType && profileFilters?.attribute) {
          updatedColumnsMap = processQuickFilterForScheduleADCampaign(
            scheduleQuickFilter,
            panes?.[index]?.adsset_value,
            profileFilters
          );
        }
      }
      let quickFilterWithSubsetFilter = null;
      if (
        updatedColumnsMap &&
        Array.from(updatedColumnsMap?.values())?.length
      ) {
        quickFilterWithSubsetFilter = scheduleQuickFilter
          ? { ...scheduleQuickFilter }
          : null;
        if (
          quickFilterWithSubsetFilter?.columns &&
          Array.isArray(quickFilterWithSubsetFilter?.columns)
        )
          quickFilterWithSubsetFilter.columns = Array.from(
            updatedColumnsMap?.values()
          );
      }
      dispatch(
        setScheduleQuickFilter(
          quickFilterWithSubsetFilter
            ? quickFilterWithSubsetFilter
            : scheduleQuickFilter,
          scheduleObj
        )
      );
    }
    dispatch(setGlobalFilter(null, index, panes, paneObj));
  };

  const locationsToShow = search.trim()
    ? filteredResults(search)
    : quickFilterOptions;

  // const StyledRow = styled.div`
  // max-height: 25rem,
  // overflow: auto
  // `;

  const getItemSize = (index) => {
    if (dontShowProfileUIFor?.includes(AccountType)) {
      return 35;
    } else if (isSupportedAccountType) {
      return 45;
    } else {
      let totalCharacters =
        (locationsToShow?.[index]?.name?.length || 0) +
        (locationsToShow?.[index]?.StoreAddress?.length || 0);
      let numberOfLines = Math.ceil(totalCharacters / 55);
      let actualHeight = numberOfLines * 16 + 60;
      return actualHeight;
    }
  };
  const renderOurRow = ({ index, style }) => {
    const el = locationsToShow[index];
    return (
      <div
        key={`${AccountType}${IsAdsSetType ? "_AdsSetType" : ""}${
          IsAdsType ? "_AdsType" : ""
        }_Row_${index}`}
        style={style}
      >
        <div className={`${!isSupportedAccountType ? "border-bottom" : ""}`}>
          <Checkbox
            onChange={(item) => handleOnSelectChange(item, el)}
            value={el?.name}
            checked={setIsCheckedOrNot(el)}
            style={{
              display: "inline-flex",
              lineHeight: "normal",
              alignItems: "center",
            }}
          >
            <Tooltip
              title={
                <div
                  className="custom_scroll pl-1 pr-1 "
                  style={{
                    maxHeight: "20rem",
                    overflow: "auto",
                    maxWidth: "25rem",
                  }}
                >
                  <p className="mb-1">{el?.name}</p>
                  {el?.StoreCode && el?.StoreCode !== "" ? (
                    <p>Store Code: {el?.StoreCode}</p>
                  ) : (
                    ""
                  )}
                </div>
              }
              placement="right"
            >
              <div
                className={`d-flex mt-1 ${
                  isSupportedAccountType
                    ? " ProfileSelection--item-container"
                    : ""
                } `}
                style={{
                  padding: dontShowProfileUIFor?.includes(AccountType)
                    ? "0.5rem 0rem"
                    : "0.5rem 1.2rem",
                  alignItems: isSupportedAccountType ? "baseline" : "",
                }}
              >
                {!isSupportedAccountType ? (
                  <div className="mr-10 multiple-quick-filter-dropdown-img">
                    <Image
                      style={{
                        width: "1.6rem",
                        height: "1.6rem",
                      }}
                      className="mt-1 "
                      preview={false}
                      src={location}
                      fallback={location}
                    />
                  </div>
                ) : AccountType === "Ads_Campaign" &&
                  (IsAdsType
                    ? el?.name !== "All ADs"
                    : IsAdsSetType
                    ? el?.name !== "All AD Sets"
                    : el?.name !== "All AD Campaigns") ? (
                  <div className="multiple-quick-filter-dropdown-img">
                    {getCampaignStatusIcons(el?.status)}
                  </div>
                ) : dontShowProfileUIFor?.includes(AccountType) ? (
                  ""
                ) : (
                  <div
                    className="position-relative profile_icon mr-15"
                    style={{ width: "3.5rem" }}
                  >
                    <Avatar
                      style={{ width: "3.5rem", height: "3.5rem" }}
                      shape="circle"
                      size="small"
                      className={`mr-0 ${
                        isSupportedAccountType ? "profile-small-icon" : ""
                      }`}
                      icon={
                        <Image
                          preview={false}
                          className="new-class"
                          src={el?.profile_icon_url}
                          fallback={defaultImage}
                        />
                      }
                    />
                    <div
                      className="position-absolute channel_icon"
                      style={{ right: "-1rem", top: "0" }}
                    >
                      <Avatar
                        style={{ width: "1.8rem", maxHeight: "1.8rem" }}
                        shape="circle"
                        size="small"
                        icon={
                          <Image
                            src={
                              SocialMedialogo?.[el?.channel]
                                ? SocialMedialogo?.[el?.channel]
                                : defaultImage
                            }
                            fallback={defaultImage}
                            preview={false}
                          />
                        }
                      />
                    </div>
                  </div>
                )}

                <div className="d-flex flex-column Location__profile--location">
                  <span className="text_heading text-wrap font-weight600 Location__profile--locationname">
                    {isSupportedAccountType ? (
                      <Text className="text_heading ml-2">
                        {el?.name?.length > 18
                          ? el?.name?.substr(0, 15) + " ..."
                          : el?.name}
                      </Text>
                    ) : (
                      el?.name
                    )}
                  </span>
                  {!isSupportedAccountType && (
                    <>
                      <span className="text-gray text-wrap break-all Location__profile--locationaddress">
                        {el?.StoreAddress}
                      </span>
                      <div className="d-flex justify-content-between Location__profile--locationratingcode">
                        <span className="mr-15 d-flex align-items-center white-space-nowrap">
                          <Tooltip placement="left" title={el?.averageRating}>
                            <Rate
                              disabled
                              value={el?.averageRating}
                              className="ratingList mr-1 mb-1"
                            />
                          </Tooltip>

                          <span className="font-weight600">
                            {el?.totalReviewCount}
                          </span>
                          <span className="font-weight600">
                            {"(" + el?.averageRating + ")"}
                          </span>
                        </span>
                        <span className="mr-15 d-flex align-items-center white-space-nowrap">
                          <span className="font-weight600 mr-1">
                            Store Code:
                          </span>{" "}
                          <span className="text-gray">
                            {el?.StoreCode?.length > 1
                              ? el?.StoreCode?.length > 10
                                ? `${el?.StoreCode?.slice(0, 10)}...`
                                : el?.StoreCode
                              : "NA"}
                          </span>
                        </span>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </Tooltip>
          </Checkbox>
        </div>
      </div>
    );
  };
  // console.log(
  //   "|------------------MultipleQuickFiltersSelectDropdown------------------|",
  //   "AccountType : ",
  //   AccountType,
  //   "type : ",
  //   type,
  //   "IsAdsSetType : ",
  //   IsAdsSetType,
  //   "IsAdsType : ",
  //   IsAdsType,
  //   "isSwitchingAllowed : ",
  //   isSwitchingAllowed,
  //   "profileSelectionInfo : ",
  //   profileSelectionInfo,
  //   "panes?.[index] : ",
  //   panes?.[index],
  //   "quickFiterValues : ",
  //   quickFiterValues,
  //   "shareTemplateData : ",
  //   shareTemplateData
  // );
  // console.log(
  //   "quickFilterOptions : ",
  //   quickFilterOptions,
  //   "selectedOptions : ",
  //   selectedOptions,
  //   "supportedAccountTypeList : ",
  //   supportedAccountTypeList,
  //   "IsAdsSetType : ",
  //   IsAdsSetType,
  //   "IsAdsType : ",
  //   IsAdsType
  // );
  return (
    <Popover
      content={
        <>
          {quickFilterOptions?.length > 0 ? (
            <div
              className="p-15"
              style={{
                width: isSupportedAccountType ? "28rem" : "50rem",
              }}
            >
              <div>
                {((isSupportedAccountType && quickFilterOptions?.length > 10) ||
                  AccountType !== "AccountID") && (
                  <Input
                    className="border-radius-4 border-color mb-3"
                    name={`${AccountType}${IsAdsSetType ? "_AdsSetType" : ""}${
                      IsAdsType ? "_AdsType" : ""
                    }_INPUT`}
                    id={`${AccountType}${IsAdsSetType ? "_AdsSetType" : ""}${
                      IsAdsType ? "_AdsType" : ""
                    }_INPUT`}
                    placeholder={
                      !isSupportedAccountType
                        ? "Search Location"
                        : AccountType === "Ads_Campaign"
                        ? `Search ${IsAdsType ? "ADs" : "AD"} ${
                            IsAdsSetType ? "Sets" : ""
                          } ${!IsAdsSetType && !IsAdsType ? "Campaign" : ""}`
                        : "Search Account"
                    }
                    style={{ height: "3.5rem" }}
                    value={search}
                    allowClear={true}
                    onChange={(e) => handleSearch(e)}
                  />
                )}
              </div>
              {locationsToShow.length > 0 ? (
                <VariableSizeList
                  ref={listRef}
                  height={
                    isSupportedAccountType
                      ? locationsToShow.length > 4
                        ? 180
                        : quickFilterOptions?.length == 1
                        ? 45
                        : locationsToShow.length * 40
                      : 250
                  }
                  width={isSupportedAccountType ? 250 : 470}
                  className={
                    quickFilterOptions?.length !== 1
                      ? "custom_scroll"
                      : "overflow-hide"
                  }
                  itemSize={getItemSize}
                  itemCount={locationsToShow.length}
                >
                  {renderOurRow}
                </VariableSizeList>
              ) : (
                <p style={{ marginLeft: "0.3rem" }}>No search result found</p>
              )}
              <div className="d-flex justify-content-between mt-2">
                <Button
                  onClick={() => handleCancel(false)}
                  className="btn_Clear mr-15"
                >
                  Cancel
                </Button>
                <Tooltip
                  title={
                    selectedOptions?.length > 50
                      ? `More than 50 ${
                          AccountType === "LocationID"
                            ? "Locations"
                            : AccountType === "Ads_Campaign"
                            ? `${IsAdsType ? "ADs" : "AD"} ${
                                IsAdsSetType ? "Sets" : ""
                              } ${
                                !IsAdsSetType && !IsAdsType ? "Campaign" : ""
                              }`
                            : isSupportedAccountType
                            ? "Accounts"
                            : "Accounts"
                        } can not be selected.`
                      : ""
                  }
                >
                  <Button
                    onClick={() => handleDone(false)}
                    type="primary"
                    className={`ant-btn-primary_blue`}
                    disabled={
                      selectedOptions?.length > 50 ||
                      selectedOptions?.length === 0
                    }
                    style={{
                      color: `${
                        (selectedOptions?.length > 50 ||
                          selectedOptions?.length == 0 ||
                          quickFilterOptions?.length === 1) &&
                        "white"
                      }`,
                    }}
                  >
                    Done
                  </Button>
                </Tooltip>
              </div>
            </div>
          ) : (
            <div
              className="p-15 d-flex justify-content-center flex-direction-column align-items-center"
              style={{ width: "40rem" }}
            >
              {/* <img
                style={{
                  width: "5rem",
                  height: "5rem",
                }}
                className="mt-1 mb-2"
                src={NoDataFound}
                fallback={NoDataFound}
              />
              <span style={{ color: "#869dad" }}>No Data</span> */}
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                style={{ margin: "auto" }}
              />
            </div>
          )}
        </>
      }
      title={null}
      trigger="click"
      open={visible}
      onOpenChange={(e) => {
        handleVisibleChange(e);
      }}
      placement="bottomLeft"
      overlayClassName={
        authParams?.theme_type === "1"
          ? "darkTheme brandsdropdown"
          : "lightTheme brandsdropdown"
      }
      key={`${AccountType}${IsAdsSetType ? "_AdsSetType" : ""}${
        IsAdsType ? "_AdsType" : ""
      }_POPOVER`}
    >
      <Tooltip
        open={!visible && visibleOfTooltip}
        onOpenChange={(e) => {
          handleVisibleChangeOfTooltip(e);
        }}
        title={
          selectedOptions?.length > 0 ? (
            <div
              className="custom_scroll pl-1 pr-1 "
              style={{
                maxHeight: "20rem",
                overflow: "auto",
                maxWidth: "25rem",
              }}
            >
              {selectedOptions?.map((obj, index) => {
                return (
                  <div
                    key={index}
                    className={`${
                      !isSupportedAccountType ||
                      dontShowProfileUIFor?.includes(AccountType)
                        ? "d-flex mt-1 ProfileSelection--item-container"
                        : "tooltip-list"
                    }`}
                  >
                    {AccountType === "Ads_Campaign" &&
                    (IsAdsType
                      ? obj?.name !== "All ADs"
                      : IsAdsSetType
                      ? obj?.name !== "All AD Sets"
                      : obj?.name !== "All AD Campaigns") ? (
                      <div className="multiple-quick-filter-dropdown-img mr-2">
                        {getCampaignStatusIcons(obj?.status)}
                      </div>
                    ) : (
                      ""
                    )}
                    <div
                      className={`position-relative profile_icon mr-15 ${
                        !isSupportedAccountType ||
                        dontShowProfileUIFor?.includes(AccountType)
                          ? "d-none"
                          : ""
                      }`}
                      style={{ width: "3.5rem" }}
                    >
                      <Avatar
                        style={{ width: "3.5rem", height: "3.5rem" }}
                        shape="circle"
                        size="small"
                        className="mr-0"
                        icon={
                          <Image
                            preview={false}
                            className="new-class"
                            src={obj?.profile_icon_url}
                            fallback={defaultImage}
                          />
                        }
                      />
                      <div
                        className="position-absolute channel_icon"
                        style={{ right: "-1rem", top: "0" }}
                      >
                        <Avatar
                          style={{ width: "1.8rem", maxHeight: "1.8rem" }}
                          shape="circle"
                          size="small"
                          icon={
                            <Image
                              src={
                                SocialMedialogo?.[obj?.channel]
                                  ? SocialMedialogo?.[obj?.channel]
                                  : defaultImage
                              }
                              fallback={defaultImage}
                              preview={false}
                            />
                          }
                        />
                      </div>{" "}
                    </div>
                    {isSupportedAccountType &&
                    !dontShowProfileUIFor?.includes(AccountType) ? (
                      <Tooltip
                        title={obj?.name?.length > 15 ? obj?.name : ""}
                        placement="right"
                      >
                        <p className="mb-1">
                          {obj?.name?.length > 15
                            ? obj?.name?.substr(0, 15) + "..."
                            : obj?.name}
                        </p>
                      </Tooltip>
                    ) : (
                      <p className="mb-1">{obj?.name}</p>
                    )}
                    {obj?.StoreCode && obj?.StoreCode !== "" ? (
                      <p>Store Code: {obj?.StoreCode}</p>
                    ) : (
                      ""
                    )}
                  </div>
                );
              })}
            </div>
          ) : (
            ""
          )
        }
        overlayStyle={{
          maxWidth: isSupportedAccountType ? "45rem" : "",
        }}
        placement="right"
        key={`${AccountType}${IsAdsSetType ? "_AdsSetType" : ""}${
          IsAdsType ? "_AdsType" : ""
        }_Tooltip-main`}
      >
        <div
          className="d-flex p-2 multiple-location-select-dropdown cursor-pointer"
          style={{
            width: isSupportedAccountType ? "25rem" : "",
            height: "4rem",
          }}
        >
          <div
            className="d-flex cursor-pointer"
            style={{ alignItems: "center" }}
          >
            <div
              className={`mr-1 Location__profile--locationicon ${
                isSupportedAccountType ? " d-none" : ""
              }`}
            >
              <Image
                style={{
                  width: "1.4rem",
                  height: "1.6rem",
                }}
                className="mt-1"
                preview={false}
                src={
                  !isSupportedAccountType
                    ? location
                    : selectedOptions?.[0]?.profile_icon_url
                }
                fallback={defaultImage}
              />
            </div>
            {isSupportedAccountType &&
            !dontShowProfileUIFor?.includes(AccountType) ? (
              <div
                className="position-relative profile_icon account_profile"
                style={{ width: "3.5rem", marginRight: "0.4rem" }}
              >
                <Avatar
                  style={{ width: "2rem", height: "2rem" }}
                  shape="circle"
                  size="small"
                  className={`mr-0 ${
                    isSupportedAccountType ? "profile-small-icon" : ""
                  }`}
                  icon={
                    <Image
                      preview={false}
                      src={
                        selectedOptions?.[0]?.profile_icon_url || defaultImage
                      }
                      fallback={defaultImage}
                    />
                  }
                />
                <div
                  className="position-absolute channel_icon"
                  style={{ right: "0.2rem", top: "-0.2rem" }}
                >
                  <Avatar
                    style={{ width: "1.8rem", maxHeight: "1.6rem" }}
                    shape="circle"
                    size="small"
                    className="small-channel-icon"
                    icon={
                      <Image
                        src={
                          SocialMedialogo?.[selectedOptions?.[0]?.channel]
                            ? SocialMedialogo?.[selectedOptions?.[0]?.channel]
                            : isSupportedAccountType
                            ? SocialMedialogo?.[
                                panes?.[index]?.hidden_filter?.columns?.[0]
                                  ?.name
                              ]
                            : defaultImage
                        }
                        fallback={defaultImage}
                        preview={false}
                      />
                    }
                  />
                </div>
              </div>
            ) : (
              ""
            )}
            {AccountType === "Ads_Campaign" &&
            (IsAdsType
              ? selectedOptions?.[0]?.name !== "All ADs"
              : IsAdsSetType
              ? selectedOptions?.[0]?.name !== "All AD Sets"
              : selectedOptions?.[0]?.name !== "All AD Campaigns") ? (
              <div className="multiple-quick-filter-dropdown-img mr-2">
                {getCampaignStatusIcons(selectedOptions?.[0]?.status)}
              </div>
            ) : (
              ""
            )}
            <span className="white-space-nowrap text-ellipsis">
              {selectedOptions?.length
                ? (selectedOptions?.[0]?.name &&
                    selectedOptions?.[0]?.name?.length) > 15
                  ? selectedOptions?.[0]?.name?.substr(0, 15) + "..."
                  : selectedOptions?.[0]?.name
                : AccountType === "Ads_Campaign"
                ? `Select ${IsAdsType ? "ADs" : "AD"} ${
                    IsAdsSetType ? "Sets" : ""
                  } ${!IsAdsSetType && !IsAdsType ? "Campaign" : ""}`
                : isSupportedAccountType
                ? "Select Accounts"
                : "Select Locations"}
            </span>{" "}
            {selectedOptions?.length > 1 &&
            ![
              "All Locations",
              "All Accounts",
              "All Location Profiles",
            ]?.includes(selectedOptions?.[0]?.name) ? (
              <span
                style={{
                  whiteSpace: "break-spaces",
                }}
              >
                {" "}
                {` +${selectedOptions?.length - 1}`}
              </span>
            ) : (
              ""
            )}
          </div>
          <div>
            <img
              src={authParams?.theme_type === "1" ? accoArrowWhite : accoArrow}
              className="accordionArrow p-0"
              alt="arrow"
            />
          </div>
        </div>
      </Tooltip>
    </Popover>
  );
};

export default React.memo(MultipleQuickFiltersSelectDropdown, isEqual);
